import { render, staticRenderFns } from "./editFreeTournament.vue?vue&type=template&id=dffd387c&"
import script from "./editFreeTournament.vue?vue&type=script&lang=js&"
export * from "./editFreeTournament.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports